module.exports = __webpack_public_path__ + "static/media/em-118.0922dbda.png";